// Bearer setup URLs must never reach error, breadcrumb, transaction, or replay
// payloads. Preserve useful diagnostics while removing credentials recursively.
const TOKEN_URL = /((?:\/|%2f)(?:toast-connect|toast_credential_link)(?:\/|%2f))[^\s/?#"'<>\\]+/gi;
const SECRET_KEY = /^(token|magic_link|client_?secret|client_?id|authorization)$/i;

export function scrubToastTelemetry(value) {
  if (typeof value === "string") {
    // SDK request data can be an already-serialized Axios JSON body.
    if (/^\s*[\[{]/.test(value)) {
      try { return JSON.stringify(scrubToastTelemetry(JSON.parse(value))); } catch (_) { /* ordinary text */ }
    }
    return value.replace(TOKEN_URL, "$1[redacted]");
  }
  if (Array.isArray(value)) return value.map(scrubToastTelemetry);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [
    key, SECRET_KEY.test(key) ? "[redacted]" : scrubToastTelemetry(item),
  ]));
}

export function isToastCredentialPage(pathname) {
  return /^\/toast-connect(?:\/|$)/i.test(pathname);
}

export function toastReplayIntegrations(Sentry, pathname) {
  // Replay's initial metadata/full DOM recording is not passed through
  // beforeSend. Never instantiate it on a public bearer-link page.
  if (isToastCredentialPage(pathname)) return [];
  return [Sentry.replayIntegration({
    maskAllText: false,
    maskAllInputs: true,
    blockAllMedia: false,
    beforeAddRecordingEvent: scrubToastTelemetry,
  })];
}
